import { render, staticRenderFns } from "./MaterialCategories.vue?vue&type=template&id=08fb6c44"
import script from "./MaterialCategories.vue?vue&type=script&lang=js"
export * from "./MaterialCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports